/* Shopnaires — light interactions ported into Dawn.
   Mobile nav drawer + newsletter form success state. Scoped to .sn-site. */
(function () {
  // Mobile nav toggle
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-nav-toggle]");
    if (btn) {
      var nav = btn.closest(".sn-site").querySelector(".site-nav");
      if (nav) {
        var open = nav.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      }
      return;
    }
    // close drawer when a nav link is tapped
    if (e.target.closest(".sn-site .site-nav a")) {
      var n = document.querySelector(".sn-site .site-nav.is-open");
      if (n) n.classList.remove("is-open");
    }
  });

  // Newsletter forms -> inline success (only decorative .signup forms without a real action)
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".sn-site .signup");
    if (!form || form.getAttribute("action")) return;
    e.preventDefault();
    var msg = form.getAttribute("data-success") || "You're in. Check your inbox to confirm.";
    var done = document.createElement("div");
    done.className = "success";
    done.innerHTML =
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
      "<span>" + msg + "</span>";
    form.replaceWith(done);
  });
})();
